import { Component, EventEmitter, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { MessageLevel, PgMessagesService } from '../../../../shared/services/pg-messages.service';
import moment from 'moment';
import { PgTitleComponent } from '../../../../shared/components/title-bar/title-bar.component';
import { NoonReportsService } from '../../services/noon-reports.service';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MaterialDateRangeComponent, DateRange } from 'src/app/shared/components/material-date-picker/material-date-range.component';
import { MaterialFileUploadComponent } from 'src/app/shared/components/material-file-uploader/material-file-uploader.component';

@Component({
  selector: 'app-import-noon-report',
  templateUrl: './import-noon-report.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports:[
    SharedModule,
    MatIconModule,
    MatButtonModule,
    MaterialDateRangeComponent,
    MaterialFileUploadComponent
  ]
})
export class ImportNoonReportComponent implements OnInit, PgTitleComponent {
  title = new EventEmitter<string>();

  currentFiles!: FileList;
  validationResult: string[] = [];
  selectedDate: DateRange;

  dtOptions: any;
  dtTrigger: Subject<any> = new Subject<any>();

  constructor(private _router: Router,
              private _noonReportService: NoonReportsService,
              private _pgMessagesService: PgMessagesService) {
    this.selectedDate = {
      startDate: moment().startOf('day').toDate(),
      endDate: moment().startOf('day').toDate(),
    };
  }

  ngOnInit() {
    this.title.emit('Import noon reports');
  }

  async uploadDocument() {
    if (this.currentFiles[0].size > 2000000) {
      confirm('The file size should be less than 2MB');
    } else {
      this._noonReportService.importV202005Report(
        moment(this.selectedDate.startDate).hour(12).utc().unix() * 1000, this.currentFiles);
      this._pgMessagesService.publishMessage({
        message: 'Imported a noon report',
        level: MessageLevel.Info,
        topic: 'Noon reports'});
    }
  }

  cancel() {
    this._router.navigate(['vessels/noon-reports']).then();
  }
}
